import cn from 'client/utils/cn';
import LangContext from 'client/utils/lang-context';

import React, { Component } from 'react';

import { PagePressReleasesProps, PressReleaseItemData } from 'client/bundles/types';
import Breadcrumbs from 'client/components/breadcrumbs';
import Subscribe from 'client/components/subscribe';
import TextNoData from 'client/components/text-no-data';

import 'client/components/text-blog/index.css';
import 'client/components/text/index.css';
import './index.css';

const _ = require('lodash');

const b = cn('press-release');
const bPageTitle = cn('page-title');

interface Props extends PagePressReleasesProps {
    baseUrl: string;
    sectionTitle: string;
}

class PressRelease extends Component<Props> {
    static contextType = LangContext;

    renderRelease = (item: PressReleaseItemData) => {
        return (
            item.markup ?
                <div
                    className={b('text', ['text', 'text-blog'])}
                    dangerouslySetInnerHTML={{ __html: item.markup }}
                    /> :
                null
        );
    }

    render() {
        const { item, sectionTitle, currentYear, baseUrl, messages } = this.props;
        const { lang } = this.context;

        if (!item) {
            return null;
        }

        const yearLink = `${baseUrl}?year=${currentYear}`;

        return (
            <div className={b()}>
                <Breadcrumbs text={sectionTitle} link={yearLink} />

                <h1 className={bPageTitle()}>{item.title}</h1>

                {item && !_.isEmpty(item) ?
                    <div className={b('content')}>
                        {this.renderRelease(item)}

                        {
                            lang === 'en' &&
                            <div className={b('subscribe')}>
                                <Subscribe />
                            </div>
                        }
                    </div> :
                    <TextNoData text={messages.notFound} />
                }
            </div>
        );
    }
}

export default PressRelease;
